// const mapStateToProps = ({ user }) => ({
//   selectedCluster: user.selectedCluster,
//   selectedScope: user.selectedScope,
//   selectedPage: store.get('app.menu.selectedKeys'),
//   AllAccessData: user.AllAccessData,
// })

// connect(mapStateToProps)

export default async function getMenuData() {
  const cluster_id = window.location.hash.replace('#/', '').split('/')[0]
  var scope_id = ''
  if (typeof window.location.hash.replace('#/', '').split('/')[1] !== 'undefined') {
    if (window.location.hash.replace('#/', '').split('/')[1] !== 'admin') {
      scope_id = '/' + window.location.hash.replace('#/', '').split('/')[1]
    }
  }
  return [
    {
      title: 'Dashboards',
      key: 'dashboard',
      icon: 'far fa-tachometer-alt',
      roles: [
        'Admin - Security Engineer',
        'Admin - SecAdmin Security Engineer',
        'Admin - Security Analyst',
        'Admin - Viewer',
        'User - Security Engineer',
        'User - SecAdmin Security Engineer',
        'User - Security Analyst',
        'User - Viewer',
      ],
      url: '/' + cluster_id + scope_id + '/dashboard',
      urlEnd: '/dashboard',
    },
    {
      title: 'Find',
      key: 'find',
      icon: 'far fa-search',
      roles: [
        'Admin - Security Engineer',
        'Admin - SecAdmin Security Engineer',
        'Admin - Security Analyst',
        'User - Security Engineer',
        'User - SecAdmin Security Engineer',
        'User - Security Analyst',
      ],
      url: '/' + cluster_id + scope_id + '/workbook/new',
      urlEnd: '/workbook/new',
    },
    {
      title: 'Cases',
      key: 'cases',
      icon: 'far fa-briefcase',
      roles: [
        'Admin - Security Engineer',
        'Admin - SecAdmin Security Engineer',
        'Admin - Security Analyst',
        'User - Security Engineer',
        'User - SecAdmin Security Engineer',
        'User - Security Analyst',
      ],
      url: '/' + cluster_id + scope_id + '/incident/cases',
      urlEnd: '/incident/cases',
    },
    {
      title: 'Signals',
      key: 'signal',
      icon: 'far fa-signal-stream',
      roles: [
        'Admin - Security Engineer',
        'Admin - SecAdmin Security Engineer',
        'Admin - Security Analyst',
        'User - Security Engineer',
        'User - SecAdmin Security Engineer',
        'User - Security Analyst',
      ],
      url: '/' + cluster_id + scope_id + '/incident/signals',
      urlEnd: '/incident/signals',
    },
    {
      title: 'Workbooks',
      key: 'workbook',
      icon: 'far fa-book',
      roles: [
        'Admin - Security Engineer',
        'Admin - SecAdmin Security Engineer',
        'Admin - Security Analyst',
        'User - Security Engineer',
        'User - SecAdmin Security Engineer',
        'User - Security Analyst',
      ],
      url: '/' + cluster_id + scope_id + '/workbook',
      urlEnd: '/workbook',
    },
    {
      title: 'Reports',
      key: 'reports',
      icon: 'far fa-file-chart-line',
      roles: [
        'Admin - Security Engineer',
        'Admin - SecAdmin Security Engineer',
        'Admin - Security Analyst',
        'User - Security Engineer',
        'User - SecAdmin Security Engineer',
        'User - Security Analyst',
      ],
      url: '/' + cluster_id + scope_id + '/reports',
      urlEnd: '/reports',
    },
    {
      title: 'MITRE ATT&CK',
      key: 'mitre_attack',
      icon: 'far fa-link',
      roles: [
        'Admin - Security Engineer',
        'Admin - SecAdmin Security Engineer',
        'Admin - Security Analyst',
        'User - Security Engineer',
        'User - SecAdmin Security Engineer',
        'User - Security Analyst',
      ],
      url: '/' + cluster_id + scope_id + '/mitre_attack',
      urlEnd: '/mitre_attack',
    },
    {
      title: 'Streams',
      key: 'streams',
      icon: 'far fa-waveform-path',
      roles: [
        'Admin - Security Engineer',
        'Admin - SecAdmin Security Engineer',
        'User - Security Engineer',
        'User - SecAdmin Security Engineer',
      ],
      url: '/' + cluster_id + scope_id + '/stream/list',
      urlEnd: '/stream/list',
    },
    {
      title: 'EBA',
      key: 'eba',
      icon: 'far fa-user-chart',
      roles: [
        'Admin - Security Engineer',
        'Admin - SecAdmin Security Engineer',
        'User - Security Engineer',
        'User - SecAdmin Security Engineer',
      ],
      url: '/' + cluster_id + scope_id + '/eba',
      urlEnd: '/eba',
    },
    {
      category: true,
      key: 'system',
      title: '',
      roles: [
        'Admin - Security Engineer',
        'Admin - SecAdmin Security Engineer',
        'User - Security Engineer',
        'User - SecAdmin Security Engineer',
      ],
    },
    {
      title: 'System',
      key: 'system',
      icon: 'far fa-tv',
      roles: [
        'Admin - Security Engineer',
        'Admin - SecAdmin Security Engineer',
        'User - Security Engineer',
        'User - SecAdmin Security Engineer',
      ],
      children: [
        {
          title: 'Utilization',
          key: 'utilization',
          roles: [
            'Admin - Security Engineer',
            'Admin - SecAdmin Security Engineer',
            'User - SecAdmin Security Engineer',
          ],
          url: '/' + cluster_id + scope_id + '/system/utilization',
          urlEnd: '/system/utilization',
        },
        {
          title: 'Collection Status',
          key: 'collection_status',
          roles: [
            'Admin - Security Engineer',
            'Admin - SecAdmin Security Engineer',
            'User - Security Engineer',
            'User - SecAdmin Security Engineer',
          ],
          url: '/' + cluster_id + scope_id + '/system/collection_status',
          urlEnd: '/system/collection_status',
        },
        {
          title: 'Enrichment',
          key: 'enrichment',
          roles: [
            'Admin - Security Engineer',
            'Admin - SecAdmin Security Engineer',
            'User - Security Engineer',
            'User - SecAdmin Security Engineer',
          ],
          url: '/' + cluster_id + scope_id + '/system/enrichment',
          urlEnd: '/system/enrichment',
        },
        {
          title: 'Eventstores',
          key: 'events',
          roles: [
            'Admin - Security Engineer',
            'Admin - SecAdmin Security Engineer',
            'User - Security Engineer',
            'User - SecAdmin Security Engineer',
          ],
          url: '/' + cluster_id + scope_id + '/system/eventstores',
          urlEnd: '/system/eventstores',
        },
        {
          title: 'Extraction',
          key: 'extraction',
          roles: [
            'Admin - Security Engineer',
            'Admin - SecAdmin Security Engineer',
            'User - Security Engineer',
            'User - SecAdmin Security Engineer',
          ],
          url: '/' + cluster_id + scope_id + '/system/extraction',
          urlEnd: '/system/extraction',
        },
        {
          title: 'Geo Enrichment',
          key: 'geodb',
          roles: [
            'Admin - Security Engineer',
            'Admin - SecAdmin Security Engineer',
            'User - Security Engineer',
            'User - SecAdmin Security Engineer',
          ],
          url: '/' + cluster_id + scope_id + '/system/geodb',
          urlEnd: '/system/geodb',
        },
        {
          title: 'Automation',
          key: 'automation',
          roles: [
            'Admin - Security Engineer',
            'Admin - SecAdmin Security Engineer',
            'User - Security Engineer',
            'User - SecAdmin Security Engineer',
          ],
          url: '/' + cluster_id + scope_id + '/system/integrations',
          urlEnd: '/system/integrations',
        },
        {
          title: 'Signal Suppression Rules',
          key: 'signalsuppression',
          roles: [
            'Admin - Security Engineer',
            'Admin - SecAdmin Security Engineer',
            'User - Security Engineer',
            'User - SecAdmin Security Engineer',
          ],
          url: '/' + cluster_id + scope_id + '/system/signalsuppression',
          urlEnd: '/system/signalsuppression',
        },
        {
          title: 'Slow Queries',
          key: 'slowQuery',
          roles: [
            'Admin - Security Engineer',
            'Admin - SecAdmin Security Engineer',
            'User - Security Engineer',
            'User - SecAdmin Security Engineer',
          ],
          url: '/' + cluster_id + scope_id + '/system/slow-queries',
          urlEnd: '/system/slow-queries',
        },
        {
          title: 'Manage Tokens',
          key: 'token',
          roles: [
            'Admin - Security Engineer',
            'Admin - SecAdmin Security Engineer',
            'User - Security Engineer',
            'User - SecAdmin Security Engineer',
          ],
          url: '/' + cluster_id + scope_id + '/system/token',
          urlEnd: '/system/token',
        },
        {
          title: 'Machine Learning',
          key: 'models',
          // icon: 'far fa-laptop-code',
          roles: ['Admin - Security Engineer', 'Admin - SecAdmin Security Engineer', 'User - Security Engineer', 'User - SecAdmin Security Engineer',],
          url: '/' + cluster_id + scope_id + '/system/models',
          urlEnd: '/system/models',
        },
        {
          title: 'Administration',
          key: 'secadmin',
          roles: [
            'Admin - Security Engineer',
            'Admin - SecAdmin Security Engineer',
            'User - SecAdmin Security Engineer',
          ],
          url: '/' + cluster_id + scope_id + '/system/components',
          urlEnd: '/system/components',
        },
      ],
    },
    {
      category: true,
      key: 'admin',
      title: '',
      roles: [
        'Admin - Security Engineer',
        'Admin - SecAdmin Security Engineer',
        'Admin - Security Analyst',
        'Admin - Viewer',
        'Admin - No Access',
      ],
    },

    {
      title: 'Administration',
      key: 'admin',
      icon: 'far fa-lock',
      roles: [
        'Admin - Security Engineer',
        'Admin - SecAdmin Security Engineer',
        'Admin - Security Analyst',
        'Admin - Viewer',
        'Admin - No Access',
      ],
      children: [
        {
          title: 'Configure SMTP',
          key: 'smtp',
          roles: [
            'Admin - Security Engineer',
            'Admin - SecAdmin Security Engineer',
            'Admin - Security Analyst',
            'Admin - Viewer',
            'Admin - No Access',
          ],
          url: '/' + cluster_id + scope_id + '/admin/smtp',
          urlEnd: '/admin/smtp',
        },
        {
          title: 'Mission Control',
          key: 'clusters',
          roles: [
            'Admin - Security Engineer',
            'Admin - SecAdmin Security Engineer',
            'Admin - Security Analyst',
            'Admin - Viewer',
            'Admin - No Access',
          ],
          url: '/' + cluster_id + scope_id + '/admin/clusters',
          urlEnd: '/admin/clusters',
        },
        {
          title: 'Manage Components',
          key: 'components',
          roles: [
            'Admin - Security Engineer',
            'Admin - SecAdmin Security Engineer',
            'Admin - Security Analyst',
            'Admin - Viewer',
            'Admin - No Access',
          ],
          url: '/' + cluster_id + scope_id + '/admin/components',
          urlEnd: '/admin/components',
        },
        {
          title: 'Compute Policy',
          key: 'compute-policy',
          roles: [
            'Admin - Security Engineer',
            'Admin - SecAdmin Security Engineer',
            'Admin - Security Analyst',
            'Admin - Viewer',
            'Admin - No Access',
          ],
          url: '/' + cluster_id + scope_id + '/admin/compute-policy',
          urlEnd: '/admin/compute-policy',
        },
        {
          title: 'Organizations',
          key: 'organization',
          roles: [
            'Admin - Security Engineer',
            'Admin - SecAdmin Security Engineer',
            'Admin - Security Analyst',
            'Admin - Viewer',
            'Admin - No Access',
          ],
          url: '/' + cluster_id + scope_id + '/admin/organizations/list',
          urlEnd: '/admin/organizations/list',
        },
        {
          title: 'Manage Users',
          key: 'user',
          roles: [
            'Admin - Security Engineer',
            'Admin - SecAdmin Security Engineer',
            'Admin - Security Analyst',
            'Admin - Viewer',
            'Admin - No Access',
          ],
          url: '/' + cluster_id + scope_id + '/admin/user/list',
          urlEnd: '/admin/user/list',
        },
        {
          title: 'Switchboard',
          key: 'switch',
          roles: [
            'Admin - Security Engineer',
            'Admin - SecAdmin Security Engineer',
            'Admin - Security Analyst',
            'Admin - Viewer',
            'Admin - No Access',
          ],
          url: '/' + cluster_id + scope_id + '/admin/switchboard',
          urlEnd: '/admin/switchboard',
        },
      ],
    },
  ]
}
